import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { change, Field, reduxForm, reset } from 'redux-form';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import {showFormatedDate,showFormattedTime, resetFiltersAndSorting, POSITIVEBEHAVIORSTEPS, BUILDABLOCKTHERAPY, DEMO, EBS, IAT} from '../../../../actions/utilAction';
import { renderDateField, renderCheckBox, renderAutoCompleteMultipleSelection } from '../../../../components/reduxFields';
import PaginatorCustom from '../../../../components/paginationCustom';
import SortingCustom from '../../../../components/SortingCustom';
import {getAppointmentList, saveEncounterWithSignature, getMasterData} from './actions/manageAppointmentAction';
import CancelAppointmentDialog from './cancelAppointmentDialogs';
import { getPatient } from './../../../Billing/components/manageClaims/actions/ManageClaimActions';

const stylescss = {
    checkbox: {
        marginBottom: 16,
    },
};

class ManageAppointments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
            ToDate: new Date(),
            responseDataAppointments: [],
            selectedAppointmentIds: [],
            finalDataObjectEncounter: {},
            AppointmentTypeIds: null,
            showCancelAppointmentDialog: false,
            PatientIds: null,
        }
        this.manageAppointmentsSubmit = this.manageAppointmentsSubmit.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.setSortColumn = this.setSortColumn.bind(this);
        this.handleNewRequestMultiSelect = this.handleNewRequestMultiSelect.bind(this);
        this.closeCancelAppointmentDialog = this.closeCancelAppointmentDialog.bind(this);
        this.filter = {
            sort_Column: 'dos',
            sort_Order: 'desc',
        };
    }

    
    componentWillMount = () => {
        let searchObj = {            
            locationIds: '0',
            isActiveCheckRequired: 'YES',
          };
        this.props.getPatient(searchObj);
        let masterData = { 'masterdata': 'APPOINTMENTTYPE', };
        this.props.getMasterData(masterData);
        this.loadData();
    }

    componentWillReceiveProps = (nextProps) => {
        if(nextProps.manageAppointments !== null) {
            this.setState({ responseDataAppointments : nextProps.manageAppointments });
        }
        else
        {
            this.setState({ responseDataAppointments : [] });
        }

        // console.log('logs...........',nextProps.savedAppointmentList , this.props.savedAppointmentList)
        if(nextProps.savedAppointmentList !== this.props.savedAppointmentList)
        {
            let appointmentData = this.props.manageAppointments.data !== undefined && this.props.manageAppointments.data;
            appointmentData.forEach((obj, appointmentIndex) => {
                let appointmentIdCheck = `Appointments[${appointmentIndex}].Chk`;
                this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, false));
            });         
            this.setState({selectedAppointmentIds: [] }, () => {this.loadData()});         
        }
    }
    

    onDateChange(input, value) {
        input.onChange(moment(value).format());
        this.setState({ [input.name]: value });        
    }

    handleNewRequestMultiSelect(input, selectedValues) {
        input.onChange(selectedValues);
        if (input.name === 'appointmentTypeIds') {
          this.setState({
            AppointmentTypeIds: selectedValues,
          });
        }    
        else if (input.name === 'PatientIds') {
            this.setState({
                PatientIds: selectedValues,
            });
        }    
      }
      

    manageAppointmentsSubmit = (event) => {
        this.setState({
            selectedAppointmentIds: [],
            FromDate: event.FromDate ? showFormatedDate(event.FromDate) : new Date(new Date().setDate(new Date().getDate() - 7)),
            ToDate: event.ToDate ? showFormatedDate(event.ToDate) : new Date(),
        }, () => {
            this.loadData();            
        })
    }

    handleReset = () => {
        this.props.dispatch(reset('ManageAppointmentsForm'));
        resetFiltersAndSorting(this.filter, 'claimid', true);
        this.setState({
            FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
            ToDate: new Date(),
            AppointmentTypeIds: null,
            showCancelAppointmentDialog: false,
            PatientIds: null,
        }, () => {
            this.loadData();                      
        })
    }

    closeCancelAppointmentDialog() {
        this.setState({ showCancelAppointmentDialog: false }, () => {                        
             this.loadData();
             this.ResetAllsessions();
        });
    }

    handleCancelBatchSessions = (event) => {
        this.setState({ showCancelAppointmentDialog: true });
    }    

    ResetAllsessions() {
        this.props.dispatch(change('ManageAppointmentsForm', 'chkAppointment', false));
        let appointmentData = this.props.manageAppointments.data !== undefined && this.props.manageAppointments.data;
        appointmentData.forEach((obj, appointmentIndex) => {
          let appointmentIdCheck = `Appointments[${appointmentIndex}].Chk`;
          this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, false));
        });
        this.setState({ selectedAppointmentIds: [] });        
      }

    checkAllAppointments = (e) => {
        let isAllAppointmentChecked = e.target.checked;
        let appointmentData = this.props.manageAppointments.data !== undefined && this.props.manageAppointments.data;
        let selectedAppointmentIds = [];
        let encounterForAgencyModel = []
        appointmentData.forEach((obj, appointmentIndex) => {

            if( this.props.agencyName.toUpperCase() === POSITIVEBEHAVIORSTEPS)
            {
                let appointmentIdCheck = `Appointments[${appointmentIndex}].Chk`;
                if(obj && isAllAppointmentChecked && obj.isBillableEncounter) {
                    let dataObject = {
                        id: 0,
                        patientID: obj.patientID,
                        patientAppointmentId: obj.patientAppointmentId,
                        dateOfService: obj.startDateTime,
                        startDateTime: obj.startDateTime,
                        endDateTime: obj.endDateTime,
                        isAdmin: false,
                        staffID: obj.staffId,
                        serviceFacility: obj.serviceFacility,
                        nonBillableNotes: obj.nonBillableNotes || '',
                        isBillableEncounter: obj.isBillableEncounter,
                        notetypeId: 1,
                        sessionNotes_PBS: [
                            {
                                id: 0,
                                patientAppointmentId: obj.patientAppointmentId,
                                notes: "N/A"                                
                            }
                        ],
                        address: obj.address,
                        patientName: obj.patientName,
                        status: obj.status,
                        phone: obj.phoneNumber,
                        isDirectService: obj.isDirectService,
                        appointmentTypeName: obj.appointmentTypeName,
                        staffName: obj.staffName,
                        encounterSignature: []
                    }
                    encounterForAgencyModel.push(dataObject)
                    selectedAppointmentIds.push(obj.patientAppointmentId);
                    this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, true));
                } else if(obj && isAllAppointmentChecked && !obj.isBillableEncounter) { 
                    let dataObject = {
                        id: 0,
                        patientID: obj.patientID,
                        patientAppointmentId: obj.patientAppointmentId,
                        dateOfService: obj.startDateTime,
                        startDateTime: obj.startDateTime,
                        endDateTime: obj.endDateTime,
                        isAdmin: false,
                        staffID: obj.staffId,
                        serviceFacility: obj.serviceFacility,
                        nonBillableNotes: "N/A",
                        isBillableEncounter: obj.isBillableEncounter,
                        notetypeId: 1,
                        sessionNotes_PBS: [],
                        address: obj.address,
                        patientName: obj.patientName,
                        status: obj.status,
                        phone: obj.phoneNumber,
                        isDirectService: obj.isDirectService,
                        appointmentTypeName: obj.appointmentTypeName,
                        staffName: obj.staffName,
                        encounterSignature: []
                    }
                    encounterForAgencyModel.push(dataObject)
                    selectedAppointmentIds.push(obj.patientAppointmentId);
                    this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, true));
                } else {
                    this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, false));
                }
            }
            else if(this.props.agencyName.toUpperCase().startsWith(EBS) || this.props.agencyName.toUpperCase() === DEMO || this.props.agencyName.toUpperCase() === BUILDABLOCKTHERAPY || this.props.agencyName.toUpperCase() === IAT)
            {
                let appointmentIdCheck = `Appointments[${appointmentIndex}].Chk`;
                if(obj && isAllAppointmentChecked && obj.isBillableEncounter) {
                    let dataObject = {
                        id: 0,
                        patientID: obj.patientID,
                        patientAppointmentId: obj.patientAppointmentId,
                        dateOfService: obj.startDateTime,
                        startDateTime: obj.startDateTime,
                        endDateTime: obj.endDateTime,
                        isAdmin: false,
                        staffID: obj.staffId,
                        serviceFacility: obj.serviceFacility,
                        nonBillableNotes: obj.nonBillableNotes || '',
                        isBillableEncounter: obj.isBillableEncounter,
                        notetypeId: 1,
                        sessionNotes_EBS: [
                            {
                                id: 0,
                                patientAppointmentId: obj.patientAppointmentId,
                                subjective: "N/A",
                                objective: "N/A",
                                assessment: "N/A",
                                plans: "N/A"
                            }
                        ],
                        address: obj.address,
                        patientName: obj.patientName,
                        status: obj.status,
                        phone: obj.phoneNumber,
                        isDirectService: obj.isDirectService,
                        appointmentTypeName: obj.appointmentTypeName,
                        staffName: obj.staffName,
                        encounterSignature: []
                    }
                    encounterForAgencyModel.push(dataObject)
                    selectedAppointmentIds.push(obj.patientAppointmentId);
                    this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, true));
                } else if(obj && isAllAppointmentChecked && !obj.isBillableEncounter) { 
                    let dataObject = {
                        id: 0,
                        patientID: obj.patientID,
                        patientAppointmentId: obj.patientAppointmentId,
                        dateOfService: obj.startDateTime,
                        startDateTime: obj.startDateTime,
                        endDateTime: obj.endDateTime,
                        isAdmin: false,
                        staffID: obj.staffId,
                        serviceFacility: obj.serviceFacility,
                        nonBillableNotes: "N/A",
                        isBillableEncounter: obj.isBillableEncounter,
                        notetypeId: 1,
                        sessionNotes_EBS: [],
                        address: obj.address,
                        patientName: obj.patientName,
                        status: obj.status,
                        phone: obj.phoneNumber,
                        isDirectService: obj.isDirectService,
                        appointmentTypeName: obj.appointmentTypeName,
                        staffName: obj.staffName,
                        encounterSignature: []
                    }
                    encounterForAgencyModel.push(dataObject)
                    selectedAppointmentIds.push(obj.patientAppointmentId);
                    this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, true));
                } else {
                    this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, false));
                }
            }
            else
            {
                let appointmentIdCheck = `Appointments[${appointmentIndex}].Chk`;
                if(obj && isAllAppointmentChecked && obj.isBillableEncounter) {
                    let dataObject = {
                        id: 0,
                        patientID: obj.patientID,
                        patientAppointmentId: obj.patientAppointmentId,
                        dateOfService: obj.startDateTime,
                        startDateTime: obj.startDateTime,
                        endDateTime: obj.endDateTime,
                        isAdmin: false,
                        staffID: obj.staffId,
                        serviceFacility: obj.serviceFacility,
                        nonBillableNotes: obj.nonBillableNotes || '',
                        isBillableEncounter: obj.isBillableEncounter,
                        notetypeId: 1,
                        soapNotes: [
                            {
                                id: 0,
                                patientAppointmentId: obj.patientAppointmentId,
                                subjective: "N/A",
                                objective: "N/A",
                                assessment: "N/A",
                                plans: "N/A"
                            }
                        ],
                        address: obj.address,
                        patientName: obj.patientName,
                        status: obj.status,
                        phone: obj.phoneNumber,
                        isDirectService: obj.isDirectService,
                        appointmentTypeName: obj.appointmentTypeName,
                        staffName: obj.staffName,
                        encounterSignature: []
                    }
                    encounterForAgencyModel.push(dataObject)
                    selectedAppointmentIds.push(obj.patientAppointmentId);
                    this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, true));
                } else if(obj && isAllAppointmentChecked && !obj.isBillableEncounter) { 
                    let dataObject = {
                        id: 0,
                        patientID: obj.patientID,
                        patientAppointmentId: obj.patientAppointmentId,
                        dateOfService: obj.startDateTime,
                        startDateTime: obj.startDateTime,
                        endDateTime: obj.endDateTime,
                        isAdmin: false,
                        staffID: obj.staffId,
                        serviceFacility: obj.serviceFacility,
                        nonBillableNotes: "N/A",
                        isBillableEncounter: obj.isBillableEncounter,
                        notetypeId: 1,
                        soapNotes: [],
                        address: obj.address,
                        patientName: obj.patientName,
                        status: obj.status,
                        phone: obj.phoneNumber,
                        isDirectService: obj.isDirectService,
                        appointmentTypeName: obj.appointmentTypeName,
                        staffName: obj.staffName,
                        encounterSignature: []
                    }
                    encounterForAgencyModel.push(dataObject)
                    selectedAppointmentIds.push(obj.patientAppointmentId);
                    this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, true));
                } else {
                    this.props.dispatch(change('ManageAppointmentsForm', appointmentIdCheck, false));
                }
            }
            
        });
        let finalDataObjectEncounter = {}
        finalDataObjectEncounter['encounterForAgencyModel'] = encounterForAgencyModel
        this.setState({
             selectedAppointmentIds : selectedAppointmentIds,
             finalDataObjectEncounter: finalDataObjectEncounter,
         });
    }

    
    checkAppointments = (e, index, data) => {
        let selectedAppointmentIds = this.state.selectedAppointmentIds;
        let finalDataObjectEncounter = this.state.finalDataObjectEncounter;
        //let encounterForAgencyModel = []
        let isAppointmentChecked = e.target.checked;
        if (isAppointmentChecked) {

            if( this.props.agencyName.toUpperCase() === POSITIVEBEHAVIORSTEPS)
            {
                if (data.patientAppointmentId && data.isBillableEncounter) {
                    let dataObject = {
                        id: 0,
                        patientID: data.patientID,
                        patientAppointmentId: data.patientAppointmentId,
                        dateOfService: data.startDateTime,
                        startDateTime: data.startDateTime,
                        endDateTime: data.endDateTime,
                        isAdmin: false,
                        staffID: data.staffId,
                        serviceFacility: data.serviceFacility,
                        nonBillableNotes: data.nonBillableNotes || '',
                        isBillableEncounter: data.isBillableEncounter,
                        notetypeId: data.noteTypeId,
                        sessionNotes_PBS: [
                            {
                                id: 0,
                                patientAppointmentId: data.patientAppointmentId,
                                notes: "N/A"                                
                            }
                        ],
                        address: data.address,
                        patientName: data.patientName,
                        status: data.status,
                        phone: data.phoneNumber,
                        isDirectService: data.isDirectService,
                        appointmentTypeName: data.appointmentTypeName,
                        staffName: data.staffName,
                        encounterSignature: []
                    }
                    selectedAppointmentIds.push(data.patientAppointmentId);
                    let encounterForAgencyModel = [];
                    encounterForAgencyModel.push(dataObject);
                    if(finalDataObjectEncounter.encounterForAgencyModel !== undefined ) {
                        finalDataObjectEncounter.encounterForAgencyModel.push(dataObject)
                    } else {
                        finalDataObjectEncounter['encounterForAgencyModel'] = encounterForAgencyModel
                    }
                } else {
                    let dataObject = {
                        id: 0,
                        patientID: data.patientID,
                        patientAppointmentId: data.patientAppointmentId,
                        dateOfService: data.startDateTime,
                        startDateTime: data.startDateTime,
                        endDateTime: data.endDateTime,
                        isAdmin: false,
                        staffID: data.staffId,
                        serviceFacility: data.serviceFacility,
                        nonBillableNotes: "N/A",
                        isBillableEncounter: data.isBillableEncounter,
                        notetypeId: data.noteTypeId,
                        sessionNotes_PBS: [],
                        address: data.address,
                        patientName: data.patientName,
                        status: data.status,
                        phone: data.phoneNumber,
                        isDirectService: data.isDirectService,
                        appointmentTypeName: data.appointmentTypeName,
                        staffName: data.staffName,
                        encounterSignature: []
                    }
                    selectedAppointmentIds.push(data.patientAppointmentId);
                    let encounterForAgencyModel = [];
                    encounterForAgencyModel.push(dataObject);
                    if(finalDataObjectEncounter.encounterForAgencyModel !== undefined ) {
                        finalDataObjectEncounter.encounterForAgencyModel.push(dataObject)
                    } else {
                        finalDataObjectEncounter['encounterForAgencyModel'] = encounterForAgencyModel
                    }
                }
            }
            else if(this.props.agencyName.toUpperCase().startsWith(EBS) || this.props.agencyName.toUpperCase() === DEMO || this.props.agencyName.toUpperCase() === BUILDABLOCKTHERAPY || this.props.agencyName.toUpperCase() === IAT)
            {
                if (data.patientAppointmentId && data.isBillableEncounter) {
                    let dataObject = {
                        id: 0,
                        patientID: data.patientID,
                        patientAppointmentId: data.patientAppointmentId,
                        dateOfService: data.startDateTime,
                        startDateTime: data.startDateTime,
                        endDateTime: data.endDateTime,
                        isAdmin: false,
                        staffID: data.staffId,
                        serviceFacility: data.serviceFacility,
                        nonBillableNotes: data.nonBillableNotes || '',
                        isBillableEncounter: data.isBillableEncounter,
                        notetypeId: data.noteTypeId,
                        sessionNotes_EBS: [
                            {
                                id: 0,
                                patientAppointmentId: data.patientAppointmentId,
                                subjective: "N/A",
                                objective: "N/A",
                                assessment: "N/A",
                                plans: "N/A"
                            }
                        ],
                        address: data.address,
                        patientName: data.patientName,
                        status: data.status,
                        phone: data.phoneNumber,
                        isDirectService: data.isDirectService,
                        appointmentTypeName: data.appointmentTypeName,
                        staffName: data.staffName,
                        encounterSignature: []
                    }
                    selectedAppointmentIds.push(data.patientAppointmentId);
                    let encounterForAgencyModel = [];
                    encounterForAgencyModel.push(dataObject);
                    if(finalDataObjectEncounter.encounterForAgencyModel !== undefined ) {
                        finalDataObjectEncounter.encounterForAgencyModel.push(dataObject)
                    } else {
                        finalDataObjectEncounter['encounterForAgencyModel'] = encounterForAgencyModel
                    }
                } else {
                    let dataObject = {
                        id: 0,
                        patientID: data.patientID,
                        patientAppointmentId: data.patientAppointmentId,
                        dateOfService: data.startDateTime,
                        startDateTime: data.startDateTime,
                        endDateTime: data.endDateTime,
                        isAdmin: false,
                        staffID: data.staffId,
                        serviceFacility: data.serviceFacility,
                        nonBillableNotes: "N/A",
                        isBillableEncounter: data.isBillableEncounter,
                        notetypeId: data.noteTypeId,
                        sessionNotes_EBS: [],
                        address: data.address,
                        patientName: data.patientName,
                        status: data.status,
                        phone: data.phoneNumber,
                        isDirectService: data.isDirectService,
                        appointmentTypeName: data.appointmentTypeName,
                        staffName: data.staffName,
                        encounterSignature: []
                    }
                    selectedAppointmentIds.push(data.patientAppointmentId);
                    let encounterForAgencyModel = [];
                    encounterForAgencyModel.push(dataObject);
                    if(finalDataObjectEncounter.encounterForAgencyModel !== undefined ) {
                        finalDataObjectEncounter.encounterForAgencyModel.push(dataObject)
                    } else {
                        finalDataObjectEncounter['encounterForAgencyModel'] = encounterForAgencyModel
                    }
                }
            }
            else
            {
                if (data.patientAppointmentId && data.isBillableEncounter) {
                    let dataObject = {
                        id: 0,
                        patientID: data.patientID,
                        patientAppointmentId: data.patientAppointmentId,
                        dateOfService: data.startDateTime,
                        startDateTime: data.startDateTime,
                        endDateTime: data.endDateTime,
                        isAdmin: false,
                        staffID: data.staffId,
                        serviceFacility: data.serviceFacility,
                        nonBillableNotes: data.nonBillableNotes || '',
                        isBillableEncounter: data.isBillableEncounter,
                        notetypeId: data.noteTypeId,
                        soapNotes: [
                            {
                                id: 0,
                                patientAppointmentId: data.patientAppointmentId,
                                subjective: "N/A",
                                objective: "N/A",
                                assessment: "N/A",
                                plans: "N/A"
                            }
                        ],
                        address: data.address,
                        patientName: data.patientName,
                        status: data.status,
                        phone: data.phoneNumber,
                        isDirectService: data.isDirectService,
                        appointmentTypeName: data.appointmentTypeName,
                        staffName: data.staffName,
                        encounterSignature: []
                    }
                    selectedAppointmentIds.push(data.patientAppointmentId);
                    let encounterForAgencyModel = [];
                    encounterForAgencyModel.push(dataObject);
                    if(finalDataObjectEncounter.encounterForAgencyModel !== undefined ) {
                        finalDataObjectEncounter.encounterForAgencyModel.push(dataObject)
                    } else {
                        finalDataObjectEncounter['encounterForAgencyModel'] = encounterForAgencyModel
                    }
                } else {
                    let dataObject = {
                        id: 0,
                        patientID: data.patientID,
                        patientAppointmentId: data.patientAppointmentId,
                        dateOfService: data.startDateTime,
                        startDateTime: data.startDateTime,
                        endDateTime: data.endDateTime,
                        isAdmin: false,
                        staffID: data.staffId,
                        serviceFacility: data.serviceFacility,
                        nonBillableNotes: "N/A",
                        isBillableEncounter: data.isBillableEncounter,
                        notetypeId: data.noteTypeId,
                        soapNotes: [],
                        address: data.address,
                        patientName: data.patientName,
                        status: data.status,
                        phone: data.phoneNumber,
                        isDirectService: data.isDirectService,
                        appointmentTypeName: data.appointmentTypeName,
                        staffName: data.staffName,
                        encounterSignature: []
                    }
                    selectedAppointmentIds.push(data.patientAppointmentId);
                    let encounterForAgencyModel = [];
                    encounterForAgencyModel.push(dataObject);
                    if(finalDataObjectEncounter.encounterForAgencyModel !== undefined ) {
                        finalDataObjectEncounter.encounterForAgencyModel.push(dataObject)
                    } else {
                        finalDataObjectEncounter['encounterForAgencyModel'] = encounterForAgencyModel
                    }
                }
            }
            
        } else {
            if (data.patientAppointmentId) {
                index = finalDataObjectEncounter.encounterForAgencyModel.findIndex((value) => value.patientAppointmentId === data.patientAppointmentId);
                if (index >= 0) {
                    finalDataObjectEncounter.encounterForAgencyModel.splice(index, 1);
                }
            }
        }
        this.setState({ 
            selectedAppointmentIds: selectedAppointmentIds,
            finalDataObjectEncounter: finalDataObjectEncounter,
         });
    }


    loadData = (page_number) => {
        let searchObj = {
            sort_fields: this.filter.sort_Column || 'dos',
            sort_order: this.filter.sort_Order || 'desc',
            contain_filters: {              
                fromDate: this.state.FromDate ? moment(this.state.FromDate).format('YYYY-MM-DD') : new Date(new Date().setDate(new Date().getDate() - 7)),
                toDate: this.state.ToDate ? moment(this.state.ToDate).format('YYYY-MM-DD') : new Date(),
                appointmentTypeIds: this.state.AppointmentTypeIds ? this.state.AppointmentTypeIds : '',
                patientIds: this.state.PatientIds ? this.state.PatientIds : '',
            },
            pageNumber: page_number ? page_number : 1,    
            pageSize: 100,  
          };
        // console.log('searchObj........',searchObj)
        this.props.getAppointmentList(searchObj);
    }

    setSortColumn(col_name, col_order) {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_Order = col_order;
            this.loadData();
        }
    }

    handleSubmitAppointments = (e) => {
        let data = this.state.finalDataObjectEncounter
        this.props.saveEncounterWithSignature(data);
        this.ResetAllsessions();
    }

    render() {
        const { handleSubmit } = this.props;
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.bordered,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'maintable': true,
            'customtable': true,
        });
        const tableClass1 = classNames({
            'table': true,
            'middletable': true,
            'customtable': true,
        });
        return (
            <div>
                <h2 className="page_title">Manage Appointments</h2>
                <div className="clearfix" />
                <div className="readmin-panel">
                    <div className="panel-body">
                        <form className="readmin-form custom_form" onSubmit={handleSubmit(this.manageAppointmentsSubmit)}>
                            <div className='row'>
                                {/* <div className="col-sm-3 mt-35">
                                    <Field
                                        name="PatientIds"
                                        label="Client Name"
                                        handleNewRequest={this.handleNewRequestMultiSelect}
                                        options={this.props.patientlist}
                                        component={renderAutoCompleteMultipleSelection} />
                                </div> */}
                                <div className="col-sm-3">
                                    <Field name="FromDate"
                                        placeholder="From Date"
                                        locale="en-US"
                                        selected={this.state.FromDate}
                                        maxDate={this.state.ToDate}
                                        onDateChange={this.onDateChange}
                                        openToYearSelection={true}
                                        component={renderDateField} />
                                </div>
                                <div className="col-sm-3">
                                    <Field name="ToDate"
                                        placeholder="To Date"
                                        locale="en-US"
                                        minDate={this.state.FromDate}
                                        maxDate={new Date()}
                                        selected={this.state.ToDate}
                                        openToYearSelection={true}
                                        onDateChange={this.onDateChange}
                                        component={renderDateField} />
                                </div>
                                <div className="col-sm-3 mt-35">
                                    <Field
                                        name="appointmentTypeIds"
                                        label="Appointment Types"
                                        handleNewRequest={this.handleNewRequestMultiSelect}
                                        options={this.props.appointmentType}
                                        component={renderAutoCompleteMultipleSelection} />
                                </div>
                            </div>    
                            <div className='row'>       
                                <div className="col-12 col-sm-12 col-md-12 btn_rt reset-btn claims_filter mt-20">
                                    <RaisedButton className="grey_btn" type="Submit" primary={true} >Filter</RaisedButton>
                                    <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>                                
                                    {this.props.bulkRenderPermission ? 
                                        <RaisedButton className={this.state.selectedAppointmentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} disabled={this.state.selectedAppointmentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleSubmitAppointments(e)} >RENDER APPOINTMENTS</RaisedButton>
                                    : null}
                                    {this.props.bulkCancelPermission ? 
                                        <RaisedButton className={this.state.selectedAppointmentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} disabled={this.state.selectedAppointmentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleCancelBatchSessions(e)} >CANCEL APPOINTMENTS</RaisedButton>
                                    : null}
                                </div>
                            </div>
                        </form>
                        {
                            this.state.showCancelAppointmentDialog ?
                                <CancelAppointmentDialog
                                patientAppointmentId={this.state.selectedAppointmentIds}                                
                                showCancelAppointmentDialog={this.state.showCancelAppointmentDialog}
                                closeCancelAppointmentDialog={this.closeCancelAppointmentDialog}/>
                                : null
                          }
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="table-responsive mt-15">
                                    <table className={tableClass}>
                                        <thead>
                                            <tr>
                                                <th width="5%">
                                                    <div className="table_custom-check">
                                                        <Field
                                                            name='chkAppointment'
                                                            component={renderCheckBox}
                                                            onChange={(e) => this.checkAllAppointments(e)}
                                                            style={stylescss.checkbox}
                                                        />
                                                        <span>&nbsp;</span>
                                                    </div>
                                                </th>
                                                <th width="20%"><SortingCustom setSortColumn={this.setSortColumn} columnName='dos' displayName='Date Of Service' /></th>                                                
                                                <th width="25%">Client Name</th>
                                                <th width="25%">Practitioner</th>
                                                <th width="15%">Appointment Type</th>
                                                <th width="15%">Billable Service</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {    this.state.responseDataAppointments && this.state.responseDataAppointments.data && this.state.responseDataAppointments.data.length > 0 ?
                                              this.state.responseDataAppointments.data.map((data, index) => {
                                                return (
                                                    <tr key={data.patientAppointmentId}>
                                                       <td colSpan="6">
                                                           <table className={tableClass1}>
                                                                <tbody>
                                                                    <tr>
                                                                        <td width="5%">
                                                                            <div className="table_custom-check">
                                                                                <Field
                                                                                    name={`Appointments[${index}].Chk`}
                                                                                    component={renderCheckBox}
                                                                                    onChange={(e) => this.checkAppointments(e, index, data)}
                                                                                    style={stylescss.checkbox}
                                                                                />
                                                                            </div>
                                                                        </td>
                                                                        <td width="20%">{showFormatedDate(data.startDateTime)}{' (' + showFormattedTime(data.startDateTime) + ' - ' + showFormattedTime(data.endDateTime) + ')'}</td>
                                                                        <td width="25%">{data.patientName ? data.patientName : 'N/A'}</td>
                                                                        <td width="25%">{data.staffName}</td>
                                                                        <td width="15%">{data.appointmentTypeName}</td>
                                                                        <td width="15%"  className={data.isBillableEncounter === true ? 'greenfont' : 'redfont'}>{data.isBillableEncounter === true ? "Yes" : "No"}</td>
                                                                    </tr>
                                                                </tbody>
                                                           </table>
                                                        </td>
                                                    </tr>
                                                      
                                                )
                                            })
                                            :
                                                <tr>
                                                    <td colSpan="6">
                                                        <div className="familydl text-center no-record">No record found.</div>
                                                    </td>
                                                </tr>
                                        }
                                        </tbody>
                                    </table>
                                </div>
                                {this.state.responseDataAppointments && this.state.responseDataAppointments.data && this.state.responseDataAppointments.data.length ?
                                    <PaginatorCustom data={this.state.responseDataAppointments.meta} handlePageChange={(pageNumber) => this.loadData(pageNumber)} />
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ManageAppointments = reduxForm({
    form: 'ManageAppointmentsForm',
})(ManageAppointments);

function mapStateToProps(state) {
    // Start For Role Permission
    let userActionPermission = [];
    if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'MANAGE_APPOINTMENTS');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'MANAGE_APPOINTMENTS_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    }

    let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

    let bulkRenderPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MANAGE_APPOINTMENTS_LIST_COMPLETE')[0].permission : false;
    let bulkCancelPermission = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === 'MANAGE_APPOINTMENTS_BULK_CANCEL')[0] ? userActionPermission.filter((obj) => obj.actionKey === 'MANAGE_APPOINTMENTS_BULK_CANCEL')[0].permission : false;


    // End For Role Permission

    let patients = [];
    if (state.billing.patientList && state.billing.patientList.data) {
        patients = state.billing.patientList.data.patients;
    }
    return {
        manageAppointments: state.manageAppointments.appointmentList,
        savedAppointmentList: state.manageAppointments.saved_appointmentList,
        appointmentType: state.manageAppointments.master_data && state.manageAppointments.master_data.appointmentType,
        agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
        patientlist: patients,
        bulkRenderPermission: bulkRenderPermission,
        bulkCancelPermission: bulkCancelPermission,
    }
}

export default connect(mapStateToProps, {getAppointmentList, saveEncounterWithSignature, getMasterData, getPatient})(ManageAppointments)



// WEBPACK FOOTER //
// ./src/modules/ManageAppointments/components/appointments/index.js